export default "__VITE_ASSET__CsK_C7Bg__"